import { render } from "./AddRayonPage.vue?vue&type=template&id=206f88d8&ts=true"
import script from "./AddRayonPage.vue?vue&type=script&lang=ts"
export * from "./AddRayonPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__